import { query, mutation } from '@/dex-shared/helpers/graphql';

export default {
  state: {
    examApplications: [],
    examApplication: null,
  },
  getters: {
    currentExamApplication: (state: any) => {
      return state.examApplication;
    },
  },
  mutations: {
    SET_EXAM_APPLICATION(state: any, examApplication: any) {
      state.examApplication = examApplication;
    },
    SET_EMPTY_EXAM_APPLICATION(state: any, mutations: any) {
      let examApplication = {
        id: null,
        title: '',
        institution: null,
        examinationBoard: null,
      };
      state.examApplication = examApplication;
    },
    SET_EXAM_APPLICATIONS(state: any, examApplications: any[]) {
      state.examApplications = examApplications.map((examApplication: any) => {
        let title = '';
        let text = '';
        if (examApplication.examTitle) {
          title += examApplication.examTitle + ' ';
        }
        if (examApplication.professionalTitle) {
          title += examApplication.professionalTitle + ' ';
        }
        if (examApplication.applicationYear) {
          title += `( ${examApplication.applicationYear} ) `;
        }
        examApplication.title = title;
        text = title;
        if (examApplication.examinationBoard) {
          text += examApplication.examinationBoard.title + ' ';
        }
        if (examApplication.institution) {
          text += examApplication.institution.title + ' ';
        }
        examApplication.text = text;
        return examApplication;
      });
    },
    REMOVE_QUESTION(state: any, index: number) {
      state.questions.splice(index, 1);
    },
  },
  actions: {
    async PULL_EXAM_APPLICATION({ commit }: any, examApplicationId: number) {
      let response = await query(
        `query pullExamApplication ($examApplicationId: Int!) {
        examApplicationById(id: $examApplicationId) {
          id
          stage
          version
          duration
          professionalTitle
          examTitle
          applicationYear
          institution: institutionByInstitutionId {
            id
            title
          }
          examinationBoard: examinationBoardByExaminationBoardId {
            id
            title
          }
        }
      }`,
        {
          examApplicationId,
        },
      );
      if (response.data.examApplicationById) {
        commit('SET_EXAM_APPLICATION', response.data.examApplicationById);
      }
    },

    async PUSH_EXAM_APPLICATION(
      { commit, state, rootState, getters }: any,
      examApplication: any,
    ) {
      let userId = rootState.auth.user ? rootState.auth.user.id : null;
      let response;
      let examApplicationResponse;
      let institution = '',
        examinationBoard = '';
      if (examApplication.institution && examApplication.institution.id) {
        institution = `institutionId: ${examApplication.institution.id},`;
      }
      if (
        examApplication.examinationBoard &&
        examApplication.examinationBoard.id
      ) {
        examinationBoard = `examinationBoardId: ${examApplication.examinationBoard.id},`;
      }
      if (examApplication.id != null) {
        response = await mutation(
          `mutation updateExamApplication (
            $examApplicationId: Int!,
            $examTitle: String,
            $applicationYear: Int,
            $professionalTitle: String,
            $duration: Int, $version: String,
            $stage: Int
          ) {
              updateExamApplicationById(
                input: {
                  id: $examApplicationId,
                  examApplicationPatch:{
                    examTitle: $examTitle,
                    ${institution}
                    ${examinationBoard}
                    applicationYear: $applicationYear,
                    professionalTitle: $professionalTitle,
                    duration: $duration,
                    version: $version,
                    stage: $stage
                  }
                }
              ){
                examApplication {
                  id
                  examTitle
                  institutionByInstitutionId {
                    id
                    title
                  }
                  examinationBoardByExaminationBoardId {
                    id
                    title
                  }
                  applicationYear
                  professionalTitle
                  duration
                  version
                  stage
                }
              }
            }`,
          {
            examApplicationId: parseInt(examApplication.id),
            examTitle: examApplication.examTitle,
            applicationYear: examApplication.applicationYear,
            professionalTitle: examApplication.professionalTitle,
            duration: parseInt(examApplication.duration),
            version: examApplication.version,
            stage: parseInt(examApplication.stage),
          },
        );
        examApplicationResponse =
          response.data.updateExamApplicationById.examApplication;
      } else {
        response = await mutation(
          `mutation createExamApplication (
            $userId: Int!,
            $examTitle: String,
            $applicationYear: Int,
            $professionalTitle: String,
            $duration: Int,
            $version: String,
            $stage: Int
          ) {
              createExamApplication(
                input: {
                  examApplication: {
                    userId: $userId,
                    examTitle: $examTitle,
                    ${institution}
                    ${examinationBoard}
                    applicationYear: $applicationYear,
                    professionalTitle: $professionalTitle,
                    duration: $duration,
                    version: $version,
                    stage: $stage
                  }
                }
              ) {
                examApplication {
                  id
                  examTitle
                  applicationYear
                  professionalTitle
                  duration
                  version
                  stage
                }
              }
            }`,
          {
            userId: userId,
            examTitle: examApplication.examTitle,
            applicationYear: examApplication.applicationYear,
            professionalTitle: examApplication.professionalTitle,
            duration: parseInt(examApplication.duration),
            version: examApplication.version,
            stage: parseInt(examApplication.stage),
          },
        );
        examApplicationResponse =
          response.data.createExamApplication.examApplication;
      }
      //TODO error inputing examApplication

      if (examApplicationResponse != null) {
        commit('SET_EXAM_APPLICATION', examApplication);
      }
    },

    async PULL_EXAM_APPLICATIONS(
      { commit }: any,
      { currentPage, resultsPerPage }: any,
    ) {
      currentPage = currentPage || 0;
      resultsPerPage = resultsPerPage || 50;
      let offset = resultsPerPage * currentPage;
      let response = await query(
        `query pullExamApplications($resultsPerPage: Int, $offset: Int){
          allExamApplications(first: $resultsPerPage, offset: $offset, orderBy: ID_DESC) {
            nodes {
              id
              stage
              version
              duration
              professionalTitle
              examTitle
              applicationYear
              institution: institutionByInstitutionId {
                id
                title
              }
              examinationBoard: examinationBoardByExaminationBoardId {
                id
                title
              }
            }
          }
        }`,
        {
          resultsPerPage,
          offset,
        },
      );
      let examApplicationsNodes = response.data.allExamApplications;
      if (examApplicationsNodes) {
        commit('SET_EXAM_APPLICATIONS', examApplicationsNodes.nodes);
      }
    },
  },
};
